import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { Input, ModalBody, ModalFooter } from 'reactstrap'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'

function AddSubtitle(props) {
  const dispatch = useDispatch()
  useEffect(() => {
    props.onChangeTitleText('')
  }, [])

  let language = props.language || {}

  return (
    <CustomModal
      courseId={props.course_id}
      size='lg'
      title={language.courses ? language.courses.add_subtitle : null}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          props.addSubtitleContainer()
          dispatch(invalidateCoursesOverview())
        }}
      >
        <ModalBody>
          <div className='row'>
            <div className='col-md-10 title-container'>
              <div className=''>
                <Input
                  type='text'
                  name='title'
                  placeholder='Subtitle'
                  autoFocus
                  value={props.title ? props.title : ''}
                  onChange={(event) =>
                    props.onChangeTitleText(event.target.value)
                  }
                  required
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className='justify-content-start  ml-2 mt-2'>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
          />
          <Link to={`/course/${props.course_id}/edit`}>
            <CancelModalButton
              text={language.general ? language.general.cancel : null}
            />
          </Link>
        </ModalFooter>
      </form>
    </CustomModal>
  )
}

export default AddSubtitle
